import { collection } from "firebase/firestore";
import { db } from "src/features/firebase/firestore/utils";

const getUsersNotificationsCollection = (id) =>
  collection(db, `users/${id}/notifications`);

export { getUsersNotificationsCollection };
